const config = {
//   admin: {
//     email: "admin@brainbees.com",
//     password: process.env.ADMIN_SECRET,
//   },
razorpayKey:process.env.REACT_APP_RAZORPAY_KEY,
baseurl :process.env.REACT_APP_BASEURL

};
module.exports = config;
